export default __webpack_public_path__ + "static/media/site_icon.354e3a5c.jpg";